import axios from 'axios';
const api_url = process.env.VUE_APP_API_VIDA_URL;

export default {
  getToken() {
    return localStorage.getItem('user-token');
  },

  async getFinancialReportCount(payload) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/financial/count`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: payload,
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar dados financeiros', error);
      throw error;
    }
  },

  async getFinancialReportDetailed(payload) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/financial/detailed`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: payload,
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar dados financeiros', error);
      throw error;
    }
  },

  async getCompanyConsultancies(companyId) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/consultancies/all/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar assesorias ', error);
      throw error;
    }
  },

  async getCovenantConsultancies(companyId) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/consultancies/by-covenant/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar assesorias ', error);
      throw error;
    }
  },

  async getCompanyCovenants(companyId) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/covenants/all/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar assesorias ', error);
      throw error;
    }
  },

  async getConsultancyBrokers(companyId) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/brokers/by-consultancy/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar assesorias ', error);
      throw error;
    }
  },
  async getCovenantBrokers(companyId) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/brokers/by-covenant/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar assesorias ', error);
      throw error;
    }
  },
  async getAllBrokers(companyId) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/brokers/all/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar assesorias ', error);
      throw error;
    }
  },

  async getCurrentAccountUsageReport(filters) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/current-account-usage`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: filters,
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async exportCurrentAccountUsageReport(filters) {
    try {
      const response = await axios.post(
        `${api_url}/admin/reports/current-account-usage/export`,
        filters,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          responseType: 'arraybuffer',
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getCovenantById(id) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/covenants/${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar convênio ', error);
      throw error;
    }
  },

  async getAutoQuotationsReport(brokerId, status, page, itemsPerPage) {
    try {
      const response = await axios.get(
        `${api_url}/reports/auto/quotations/detailed`,
        {
          params: {
            brokerId,
            status,
            page,
            itemsPerPage,
          },
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar assesorias ', error);
      throw error;
    }
  },

  async getAutoQuotationsCount(brokerId) {
    try {
      const response = await axios.get(
        `${api_url}/reports/auto/quotations/count`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            brokerId,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar assesorias ', error);
      throw error;
    }
  },

  async exportMicroLifeReport(filters) {
    try {
      const response = await axios.get(`${api_url}/admin/reports/micro-life`, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: filters,
        responseType: 'arraybuffer',
      });
      return response.data;
    } catch (error) {
      console.log('Erro ao buscar dados financeiros', error);
      throw error;
    }
  },

  async getFullContext() {
    try {
      const response = await axios.get(`${api_url}/admin/context`, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      return response.data;
    } catch (error) {
      console.log(
        'Falha ao buscar os dados das corretoras, assessorias e convenios',
        error,
      );
      throw error;
    }
  },

  async getUserContext() {
    try {
      const response = await axios.get(
        `${api_url}/admin/context/user-context`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(
        'Falha ao buscar os dados das corretoras, assessorias e convenios',
        error,
      );
      throw error;
    }
  },

  async exportPaymentReport(filters) {
    try {
      const response = await axios.get(`${api_url}/admin/reports/payment`, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: filters,
        responseType: 'arraybuffer',
      });
      return response.data;
    } catch (error) {
      console.log('Falha ao gerar relatório de pagamentos', error);
      throw error;
    }
  },

  async exportReceivedInstallmentReport(filters) {
    try {
      const response = await axios.get(
        `${api_url}/reports/received-installments`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: filters,
          responseType: 'arraybuffer',
        },
      );
      return response.data;
    } catch (error) {
      console.log('Falha ao gerar relatório de parcelas recebidas', error);
      throw error;
    }
  },
  async exportBilletReport(filters) {
    try {
      const response = await axios.get(`${api_url}/admin/reports/billets`, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: filters,
        responseType: 'arraybuffer',
      });
      return response.data;
    } catch (error) {
      console.log('Falha ao gerar relatório de boletos', error);
      throw error;
    }
  },

  async exportRefundsReport(filters) {
    try {
      const response = await axios.get(`${api_url}/admin/reports/refund`, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: filters,
        responseType: 'arraybuffer',
      });
      return response.data;
    } catch (error) {
      let errorMessage =
        'Ocorreu um erro ao gerar o relatório. Tente novamente';

      if (error.response && error.response.data) {
        try {
          const decoder = new TextDecoder('utf-8');
          const responseText = decoder.decode(
            new Uint8Array(error.response.data),
          );

          const objectError = JSON.parse(responseText);

          if (objectError && objectError.errors) {
            errorMessage = objectError.errors;
            if (Array.isArray(errorMessage)) {
              errorMessage = errorMessage.join(', ');
            }
          }
        } catch (e) {
          console.log('Falha ao interpretar erro: ' + e.message);
        }
      }
      throw errorMessage;
    }
  },

  async getCompaniesByTypeOptions(companyType) {
    try {
      const response = await axios.get(
        `${api_url}/admin/user-company/type/${companyType}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async exportIndividualCarReport(filters) {
    try {
      const response = await axios.get(
        `${api_url}/admin/reports/individual-auto-report`,

        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: filters,
          responseType: 'arraybuffer',
        },
      );
      return response.data;
    } catch (error) {
      console.log('Falha ao gerar relatório de pagamentos', error);
      throw error;
    }
  },
};
